export function expandTree(tree, depth = 1) {
  tree.nodes().forEach(n => {
    n.opened = n.depth <= depth;
  });
  return tree;
}
